module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.subCatalogId == '1010120' || _vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220') ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "复合适应症"
    }
  }), _vm._v(" "), (_vm.subCatalogId == '1010120' || _vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220') ? _c('div', {
    staticClass: "composite",
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "composite-div"
  }, [_c('div', {
    staticClass: "composite-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options1),
      expression: "options1"
    }],
    ref: "check-op1",
    staticClass: "custom-box",
    attrs: {
      "type": "checkbox",
      "id": "options-1"
    },
    domProps: {
      "checked": Array.isArray(_vm.options1) ? _vm._i(_vm.options1, null) > -1 : (_vm.options1)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.options1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options1 = $$c
        }
      }, function($event) {
        return _vm.checkChange()
      }]
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options2),
      expression: "options2"
    }],
    ref: "check-op2",
    staticClass: "custom-box",
    staticStyle: {
      "margin-left": "7%"
    },
    attrs: {
      "type": "checkbox",
      "id": "options-2"
    },
    domProps: {
      "checked": Array.isArray(_vm.options2) ? _vm._i(_vm.options2, null) > -1 : (_vm.options2)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.options2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options2 = $$c
        }
      }, function($event) {
        return _vm.checkChange(2)
      }]
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options3),
      expression: "options3"
    }],
    ref: "check-op3",
    staticClass: "custom-box",
    staticStyle: {
      "margin-left": "7%"
    },
    attrs: {
      "type": "checkbox",
      "id": "options-3"
    },
    domProps: {
      "checked": Array.isArray(_vm.options3) ? _vm._i(_vm.options3, null) > -1 : (_vm.options3)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options3 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.options3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options3 = $$c
        }
      }, function($event) {
        return _vm.checkChange(3)
      }]
    }
  }), _vm._v(" "), _vm._m(3)])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label",
    staticStyle: {
      "width": "100px",
      "margin-left": "-4px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("复合适应症")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "txt-label",
    attrs: {
      "for": "options-1"
    }
  }, [_vm._v("\n          上部种植修复冠\n          "), _c('img', {
    staticClass: "select-icon",
    attrs: {
      "src": "/static/images/order/catalog_sub/10_101_20_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "txt-label",
    attrs: {
      "for": "options-2"
    }
  }, [_vm._v("\n          基台设计(金属)\n          "), _c('img', {
    staticClass: "select-icon",
    attrs: {
      "src": "/static/images/order/catalog_sub/10_101_20_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "txt-label",
    attrs: {
      "for": "options-3"
    }
  }, [_vm._v("\n          基台设计(全瓷)\n          "), _c('img', {
    staticClass: "select-icon",
    attrs: {
      "src": "/static/images/order/catalog_sub/10_101_20_2_1.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d729dbe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/orderCreate/CompositeIndication/selIndication.vue
// module id = 654
// module chunks = 0